import React from 'react'
import Modal from '@mui/material/Modal';
import Box from '@mui/material/Box';
import Image from 'next/image';
import Link from 'next/link';
import moment from 'moment';
import { company } from '@components/config/Company';
import useMediaQuery from '@mui/material/useMediaQuery';
function ConfirmModal({ open, handleClose, dateTime, timeRequired }) {
    const time = moment(dateTime).format('LT')
    const matches = useMediaQuery('(min-width:600px)');
    const dateOnly = moment(dateTime).format('LL')
    const style = {
        position: 'absolute',
        top: '50%',
        left: '50%',
        transform: 'translate(-50%, -50%)',
        width: matches ? 600 : 300,
        bgcolor: 'background.paper',
        border: '2px solid #000',
        boxShadow: 24,
        p: 4,
    };
    return (
        <div>
            <Modal
                open={open}
                onClose={handleClose}
                aria-labelledby="modal-modal-title"
                aria-describedby="modal-modal-description"
            >
                <Box sx={style}>
                    <div className='flex items-center justify-center'>
                        <Image
                            src='/assets/images/tickg.gif'
                            width={matches ? 200 : 70}
                            height={matches ? 200 : 70}
                            alt='tick'
                        />
                    </div>
                    <div className='text-center text-xl my-2 font-semibold'>Confirmed</div>
                    {/* <div className='text-center text-md my-3 '>Thank you {name}<br />
                        Your appointment is confirmed on {dateOnly} at {time} with our driver onboarding team. We are looking forward to welcoming you to 247 Radio Carz.<br />
                        If you need to reschedule, cancel or have any questions related to the appointment, please do not hesitate to contact us on <Link href={`tel:${company[0].tel_number}`}>
                            <a className='underline'>{company[0].tel_number}</a></Link>.<br />
                        Please note that the appointment will be held at our office at {company[0].address.building} {company[0].address.street} {company[0].address.town} , {company[0].address.postcode} unless otherwise specified. Kindly arrive on time to ensure a smooth and efficient service.
                    </div> */}
                    <div className='text-center text-black/70 pb-4 mb-4 '>
                        Thank you for setting up an appointment with our driver onboarding team on {dateTime}. You can find us at {company[0].address.building} {company[0].address.street} {company[0].address.town} {company[0].address.postcode}. Please make sure to have all necessary documents with you and arrive 15 minutes in advance. We look forward to meeting you!
                    </div>
                    {/* <div className='text-center text-xl'>{timeRequired}{dateTime}</div> */}
                    <div onClick={handleClose} className='text-center border border-black/20 py-2 mt-4 cursor-pointer hover:text-white hover:bg-black transition-all rounded'>Close</div>
                </Box>
            </Modal>
        </div>
    )
}

export default ConfirmModal